import { clearSession as clearChatSession } from '../components/ChatPanel/backend/matrix/session'
import { normalizeRoutePath } from './routeUtils'
import { AUTH_STORAGE_KEY } from './sessionToken'

export const GUEST_JOIN_PATH = '/meeting/join'

/**
 * Cached data that belongs to whoever was signed in (owners: `CompanyService.clearCache`,
 * `AccountStatusService.clearCache`).
 */
const SIGNED_IN_CACHE_KEYS = ['wiggin_company_data', 'wiggin_is_admin', 'wiggin_account_status']

const PARSE_CURRENT_USER_KEY = /^Parse\/.+\/currentUser$/

export function isGuestJoinLocation(location: { pathname: string; search: string }): boolean {
  if (normalizeRoutePath(location.pathname) !== GUEST_JOIN_PATH) return false
  return !!new URLSearchParams(location.search).get('token')
}

/**
 * Forget the Sevv account saved in this browser, locally only (the server session is not revoked).
 * A guest has no Parse login: if one is left in storage, the boot session check restores it and the
 * guest's chat, company permissions and Parse writes run as that account.
 */
export function clearSavedLogin(): void {
  try {
    const parseKeys: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && PARSE_CURRENT_USER_KEY.test(key)) parseKeys.push(key)
    }
    for (const key of [...parseKeys, AUTH_STORAGE_KEY, ...SIGNED_IN_CACHE_KEYS]) {
      localStorage.removeItem(key)
    }
  } catch {
    /* storage can throw (Safari private mode); nothing was saved then */
  }
  clearChatSession()
}

/**
 * Must run before any module reads the Parse current user or the stored session, so it is imported
 * first in `index.tsx`. Returns whether the saved login was cleared.
 */
export function clearSavedLoginOnGuestJoin(
  location: { pathname: string; search: string } = window.location
): boolean {
  if (!isGuestJoinLocation(location)) return false
  clearSavedLogin()
  return true
}
